import React from "react";
import { getRequest } from "sharedUtils/httpUtils";
import MUIDataTable from "mui-datatables";
import { convertToNumericMonthAndDayAndYearAndTime } from "sharedUtils/timeUtils";
import { ThemeProvider, createTheme } from "@material-ui/core/styles";
import { CheckIconBlack } from "../../icons";
import PenIcon from "components/icons/PenIcon";

const { DateTime } = require("luxon");

class DigiDipCommissionData extends React.Component {
    constructor(props) {
        super(props);
        this.tableRef = React.createRef();

        this.state = {
            commissions: [],
            commissionsLoading: false,
            affiliateCommissionId: this.props.affiliateCommissionId,
            affiliateCommissionIdError: false,
            CommissionsTable: {
                title: "Affiliate commissions",
                options: {
                    selectableRows: "multiple",
                    rowsPerPage: 100,
                    sortOrder: {
                        name: 'commissionName',
                        direction: 'asc'
                    },
                },
                getTheme: () => createTheme({
                    typography: {
                        fontFamily: "'Urbanist', 'sf_pro_displayregular', sans-serif",
                    },
                    overrides: {
                        MUIDataTableBodyRow: {
                            root: {
                                '&:nth-child(odd)': {
                                    backgroundColor: '#F9F9F9'
                                },
                                cursor: 'pointer'
                            }
                        },
                        MUIDataTableBody: {
                            emptyTitle: {
                                textAlign: 'left',
                                paddingLeft: '385px',
                                paddingTop: '12px',
                                verticalAlign: 'top',
                                fontFamily: "'Urbanist', sans-serif",
                                fontSize: '16px',
                            }
                        }
                    }
                })
            },
        };
    }

    componentDidMount = () => {
        window.scrollTo({ left: 0, top: 0, behavior: 'auto' });

        if (!!(this.props.affiliateCommissionId)) {
            this.getCommissions();
        }
    };

    componentDidUpdate = (prevProps, prevState) => {
        if (!!(this.props.affiliateCommissionId) && prevProps.affiliateCommissionId !== this.props.affiliateCommissionId) {
            this.getCommissions();
        }
    }

    getCommissions = async () => {
        if (!(this.props.affiliateCommissionId)) {
            this.setState({ affiliateCommissionIdError: true });
        }

        let url = `/api/Merchant/GetDigiDipCommissionRawDataById?id=` + this.props.affiliateCommissionId;

        this.setState({ commissionsLoading: true, affiliateCommissionIdError: false });

        try {
            const commissions = await getRequest(url);

            this.setState({
                commissions,
                commissionsLoading: false,
            });
        } catch (error) {
            console.error("Error fetching commissions:", error);
            this.setState({ commissions: [], commissionsLoading: false });
        }
    };

    onTabChange = (tab) => {
        this.setState({ tab });
    }

    render() {
        const columns = [
            {
                name: "digiDipCommissionId",
                label: "DigiDip Commission ID",
                options: { filter: true, sort: true }
            },
            {
                name: "digiDipTransactionId",
                label: "DigiDip Transaction ID",
                options: { filter: true, sort: true }
            },
            {
                name: "userId",
                label: "User ID",
                options: { filter: true, sort: true }
            },
            {
                name: "digiDipCommissionHistoryId",
                label: "DigiDip Commission History ID",
                options: { filter: true, sort: true }
            },
            {
                name: "orderId",
                label: "Order ID",
                options: { filter: true, sort: true }
            },
            {
                name: "status",
                label: "Status",
                options: { filter: true, sort: true }
            },
            {
                name: "dateTimestamp",
                label: "Date Timestamp",
                options: { filter: true, sort: true }
            },
            {
                name: "dateIso8601",
                label: "Date ISO8601",
                options: { filter: true, sort: true }
            },
            {
                name: "lastModifiedDateTimestamp",
                label: "Last Modified Date Timestamp",
                options: { filter: true, sort: true }
            },
            {
                name: "lastModifiedDateIso8601",
                label: "Last Modified Date ISO8601",
                options: { filter: true, sort: true }
            },
            {
                name: "priceAmount",
                label: "Price Amount",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => (
                        <span>{value != null ? `$${value.toFixed(2)}` : "-"}</span>
                    )
                }
            },
            {
                name: "commissionAmount",
                label: "Commission Amount",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => (
                        <span>{value != null ? `$${value.toFixed(2)}` : "-"}</span>
                    )
                }
            },
            {
                name: "currency",
                label: "Currency",
                options: { filter: true, sort: true }
            },
            {
                name: "projectId",
                label: "Project ID",
                options: { filter: true, sort: true }
            },
            {
                name: "projectName",
                label: "Project Name",
                options: { filter: true, sort: true }
            },
            {
                name: "merchantId",
                label: "Merchant ID",
                options: { filter: true, sort: true }
            },
            {
                name: "merchantName",
                label: "Merchant Name",
                options: { filter: true, sort: true }
            },
            {
                name: "clickDateTimestamp",
                label: "Click Date Timestamp",
                options: { filter: true, sort: true }
            },
            {
                name: "clickDateIso8601",
                label: "Click Date ISO8601",
                options: { filter: true, sort: true }
            },
            {
                name: "clickReference",
                label: "Click Reference",
                options: { filter: true, sort: true }
            },
            {
                name: "clickUrlsOriginHref",
                label: "Click Origin Href",
                options: { filter: true, sort: true }
            },
            {
                name: "clickUrlsTargetHref",
                label: "Click Target Href",
                options: { filter: true, sort: true }
            },
            {
                name: "disbursementCreditNoteIds",
                label: "Disbursement Credit Note Ids",
                options: { filter: true, sort: true }
            },
            {
                name: "createdBy",
                label: "Created By",
                options: { filter: true, sort: true }
            },
            {
                name: "createdDate",
                label: "Created Date",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => (
                        <span>{!!value ? convertToNumericMonthAndDayAndYearAndTime(new Date(value), false) : "-"}</span>
                    )
                }
            },
            {
                name: "modifiedBy",
                label: "Modified By",
                options: { filter: true, sort: true }
            },
            {
                name: "modifiedDate",
                label: "Modified Date",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => (
                        <span>{!!value ? convertToNumericMonthAndDayAndYearAndTime(new Date(value), false) : "-"}</span>
                    )
                }
            }
        ];

        return (
            <div>
                <ThemeProvider theme={this.state.CommissionsTable.getTheme()}>
                    <MUIDataTable
                        title={
                            <div style={{ fontFamily: "'Urbanist', sans-serif", position: "relative" }}>
                                <p style={{ fontSize: '22px', marginTop: "20px" }}>{this.props.affiliateProgramManager?.name + " commissions by ID" ?? "No affiliate selected"}</p>
                                <span style={{ display: this.props.affiliateProgramManager?.id === 1 ? "" : "none", position: "absolute", top: "-2px", left: "300px", width: "150px", fontSize: "11px" }}>*CJ uses CjCommissionHistory.OrderId</span>
                                <p style={{ fontSize: '16px', marginTop: "10px", color: "red", display: this.state.affiliateCommissionIdError ? "" : "none" }}>Enter an affiliate commission ID</p>
                            </div>
                        }
                        data={this.state.commissions}
                        columns={columns}
                        options={{
                            ...this.state.CommissionsTable.options,
                            textLabels: {
                                body: { noMatch: this.state.commissionsLoading ? "LOADING..." : "No data available" },
                            },
                            selectableRows: "none",
                        }}
                        ref={this.tableRef}
                    />
                </ThemeProvider>
            </div>
        );
    }
}

export default DigiDipCommissionData;
